export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/health_medical.b7b49d8.svg";